import FileSaver from "file-saver";
function dataURItoBlob(dataURI) {
  const byteString = atob(dataURI.split(",")[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  const blob = new Blob([ab], { type: "application/pdf" });
  return blob;
}
function download(data, strFileName, strMimeType) {
  const blob = dataURItoBlob(data);
  FileSaver.saveAs(blob, "dpd-chat-transcript.pdf");
}
export {
  download as default
};
//# sourceMappingURL=download.js.map
